import React, { useEffect, useState } from 'react';

import '../swiper.min.css';
import '../Mance.css'; 
import ProgressBarComponent from '../Components/ProgressBarComponent';
import { getUserManceAuthData, notifyManceAssociation } from '../services/API';
import updateUserData from '../Redux/updateUser';
import { useSelector } from 'react-redux';
import updateWalletData from '../Redux/updateWallet';
import { associateFTMance, disconnect, initConnection, manualListener, pairHashpack } from '../Hashconnect';
import toast, { Toaster } from 'react-hot-toast';
import QRCode from "react-qr-code";
import { addToClipBoard } from '../Helpers/helpers';
const RantCPU = () => {
    const [loading, setLoading] = useState(false);
	const [pairingString, setPairingString] = useState('');
	const [loadingMessage, setLoadingMessage] = useState("Loading ...");
	const [isConnectWindowOpen, setConnectWindowOpen] = useState(false);
	const [isConnecting, setIsConnecting] = useState(false);
    const [isClaimSuccessFul, setIsClaimSuccessful] = useState(false);
	const userId = useSelector((state: any) => state.user.userId);
	const isFakeWallet = useSelector((state: any) => state.wallet.isFakeWallet)
    const isFounder = useSelector((state: any) => state.user.isFounder)
    const isConnected = useSelector((state: any) => state.user.isConnected)
    const [isAssociationSuccessFul, setIsAssociationSuccessful] = useState(false);
    const isManceTierAssociated = useSelector((state: any) => state.user.isManceTierAssociated)
    const isManceTierOwner = useSelector((state: any) => state.user.isManceTierOwner)
    const isLeemonTierAssociated = useSelector((state: any) => state.user.isLeemonTierAssociated)
    const isLeemonTierOwner = useSelector((state: any) => state.user.isLeemonTierOwner)
    const manceAndLeemonStatus = useSelector((state: any) => state.user.manceAndLeemonStatus)


	async function closeSuccessModal() {
        setIsAssociationSuccessful(false)
        setIsClaimSuccessful(false)
    }

	useEffect(() => {
			  getUserData();
	}, [ ]);
    async function closeFakeWalletModal() {
		updateWalletData(false)
	}

	async function getUserData() {
		try {
			setLoadingMessage("Fetching user data...")
			setLoading(true)
			let token: string | null = localStorage.getItem("accessToken");
			if (token) {
				const authData = await getUserManceAuthData(token);
				const id = authData.id;
				if (id) {
					updateUserData(id, authData, true)
				}
				setLoading(false)
				setLoadingMessage("Loading...")

			} else {
				setLoading(false)
				setLoadingMessage("Loading...")
			}
		} catch (error) {

		}
	}


    async function browserExtension() {
		try {
			setConnectWindowOpen(false);
			setIsConnecting(false)
			setLoadingMessage("Pairing...")
			setLoading(true)
			await pairHashpack(setLoading);
			setLoading(false)
			setLoadingMessage("Loading...")
		} catch (error) {

		}
	}

	async function disconnectBrowserExtension() {
		try {
			setLoadingMessage("Disconnecting...")
			setLoading(true)
			await disconnect();
			updateUserData("", [], false)
			setLoading(false)
			setLoadingMessage("Loading...")
		} catch (error) {

		}
	}

	const openConnectWindow = () => {
		setConnectWindowOpen(true);
	};

	const closeConnectWindow = () => {
		setConnectWindowOpen(false);
		setIsConnecting(false)
	};

	async function startConnectionProcess() {
        setIsConnecting(true)
		manualListener(setLoading, setIsConnecting, setConnectWindowOpen)
		const saveData:any = await initConnection()
		setPairingString(saveData.pairingString)
	}
	const notify = () => toast.success('Text Copied!');

    async function associateToken() {
        try {
            // console.log("cargando")
            setLoading(true)
            await associateFTMance(setIsClaimSuccessful);
            setTimeout(async () => {
                await getUserData()
              }, 2000);
            setTimeout(async () => {
                await getUserData()
              }, 15000);
            setLoading(false)
        } catch (error) {

        }
    }

    async function claimFTTokens() {
        setLoading(true)
        await notifyManceAssociation(setIsClaimSuccessful);
        setTimeout(async () => {
            await getUserData()
          }, 2000);
        setTimeout(async () => {
            await getUserData()
          }, 15000);
        setLoading(false)
    }

  return (
    <>
    {(loading === true) ?
        <ProgressBarComponent loadingMessage={loadingMessage} />
        :
        <></>
    }
    		{(isClaimSuccessFul) ?
				<div id="connectWindowContainer" className="connectWindowContainer">
					<div className="connectWindow">
						<span className='notification-icon'>
							<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><g fill="none" stroke="green" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="m24 4l5.253 3.832l6.503-.012l1.997 6.188l5.268 3.812L41 24l2.021 6.18l-5.268 3.812l-1.997 6.188l-6.503-.012L24 44l-5.253-3.832l-6.503.012l-1.997-6.188l-5.268-3.812L7 24l-2.021-6.18l5.268-3.812l1.997-6.188l6.503.012L24 4Z" /><path d="m17 24l5 5l10-10" /></g></svg>
						</span>
						<span className='notification-text qr'>Request successfully sent. <br></br> You will receive the airdrop in a few minutes.</span>

						<span className="btnWallets ok" onClick={() => closeSuccessModal()}>OK</span>
						<div className="rantCPU_04"></div>
					</div>
				</div>
				:
				<></>
			}
			{(isAssociationSuccessFul) ?
				<div id="connectWindowContainer" className="connectWindowContainer">
					<div className="connectWindow">
						<span className='notification-icon'>
							<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48"><g fill="none" stroke="green" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="m24 4l5.253 3.832l6.503-.012l1.997 6.188l5.268 3.812L41 24l2.021 6.18l-5.268 3.812l-1.997 6.188l-6.503-.012L24 44l-5.253-3.832l-6.503.012l-1.997-6.188l-5.268-3.812L7 24l-2.021-6.18l5.268-3.812l1.997-6.188l6.503.012L24 4Z" /><path d="m17 24l5 5l10-10" /></g></svg>
						</span>
						<span className='notification-text qr'>Tokens successfully associated.</span>

						<span className="btnWallets ok" onClick={() => closeSuccessModal()}>OK</span>
						<div className="rantCPU_04"></div>
					</div>
				</div>
				:
				<></>
			}
    			{(isConnectWindowOpen && !isConnecting) ?
				<div id="connectWindowContainer" className="connectWindowContainer">
					<div className="connectWindow">
						<span className="btnCloseContainer">Connect Wallet
							<div id="btnCloseWindow" className="btnCloseWindow" onClick={() => { closeConnectWindow() }}>
								<span className="material-symbols-outlined">close</span>
							</div>
						</span>
						<div className="btnWallets" id="btnHashpack" onClick={() => startConnectionProcess()}>
							<div>
								<div className="icon iconHashpack"></div>
								<span> Hashpack</span>
							</div>
							<span className="material-symbols-outlined">
								arrow_right_alt
							</span>
						</div>
						<span className="btnWallets cancel" onClick={() => { closeConnectWindow() }}>Cancel</span>
						<div className="rantCPU_04"></div>
					</div>
				</div>
				:
				(isConnecting) ?
					<div id="connectWindowContainer" className="connectWindowContainer">
						<div className="connectWindow open">
							<span className="btnCloseContainer">Connect Wallet
								<div id="btnCloseWindow" className="btnCloseWindow" onClick={() => { closeConnectWindow() }}>
									<span className="material-symbols-outlined">close</span>
								</div>
							</span>
							<div className='scan-container'>
								<h3 className='scan-text'>
									Scan the QR Code with your HashPack mobile app
								</h3>

								<QRCode className='qr' value={pairingString} />
								<button className="btn--secondary mb-2" onClick={() => { addToClipBoard(pairingString); notify() }}>Copy Pairing String</button>
								<Toaster  position="bottom-center" reverseOrder={false}/>
								<button className="btn--primary mb-2" onClick={browserExtension}>
									<span>Browser Extension</span>
								</button>
								<span className="btnWallets cancel" onClick={() => { closeConnectWindow() }}>Cancel</span>
							</div>
							<div className="rantCPU_04"></div>
							<br></br>
						</div>
					</div>
					:
					<></>
			}


			{(isFakeWallet) ?
				<div id="connectWindowContainer" className="connectWindowContainer">
					<div className="connectWindow">
						<span className='notification-icon02'>
							<svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72"><g stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"><path fill="#fcea2b" d="M32.522 13.005c.698-1.205 1.986-2.024 3.478-2.024c1.492 0 2.78.82 3.478 2.024L60.446 54.94A4 4 0 0 1 61 56.948a4.032 4.032 0 0 1-4.032 4.033l-41.936.017A4.033 4.033 0 0 1 11 56.966c0-.736.211-1.415.554-2.009l20.968-41.952" /><path fill="#FFF" d="M37.613 47.27a1.613 1.613 0 0 1-3.226 0V23.893a1.613 1.613 0 0 1 3.226 0v23.379z" /><circle cx="36" cy="54.529" r="1.613" fill="#FFF" /></g><g fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"><path d="M32.522 13.005c.698-1.205 1.986-2.024 3.478-2.024c1.492 0 2.78.82 3.478 2.024L60.446 54.94A4 4 0 0 1 61 56.948a4.032 4.032 0 0 1-4.032 4.033l-41.936.017A4.033 4.033 0 0 1 11 56.966c0-.736.211-1.415.554-2.009l20.968-41.952" /><path d="M37.613 47.27a1.613 1.613 0 0 1-3.226 0V23.893a1.613 1.613 0 0 1 3.226 0v23.379z" /><circle cx="36" cy="54.529" r="1.613" /></g></svg>
						</span>
						<span className='notification-text qr'>This address does not exist on Hedera Network.<br></br>
							Please try To login with a different wallet address.</span>
						<span className="btnWallets ok" onClick={() => closeFakeWalletModal()}>OK</span>
						<div className="rantCPU_01"></div>
					</div>
				</div>
				:
				<></>
			}
    <section>
      <div className="content row">
        <div className="col-sm-5">
          <div className="swiper">
            <div className="swiper-wrapper">
              <div className="swiper-slide"></div>
              <div className="swiper-slide"></div>
            </div>
          </div>
        </div>

        <div className="info col-sm-6">
          <p>
            This <span className="movie-night">limited</span> edition series is a tribute to innovation and excellence in the blockchain sphere, offering collectors a unique opportunity to own a piece of crypto history. Celebrate with us, as we honor the minds behind Hedera's success.
          </p>
       
          {/* {
      (isLeemonTierAssociated
                    && isManceTierOwner
                    && isLeemonTierOwner
                    && isManceTierAssociated
                    && isFounder
                    && manceAndLeemonStatus === 'CLAIMED')
                    ?
                    <>
                    <button disabled={true} className='btn2'>CLAIMED <span className="icoLocked material-symbols-outlined">lock</span></button>
                    </>
                    :
                    (isLeemonTierAssociated
                        && !isManceTierOwner
                        && !isLeemonTierOwner
                        && isManceTierAssociated
                        && isFounder
                        && manceAndLeemonStatus === 'CREATED')
                        ?
                        <>
                        <button disabled={true} className='btn2' >PROCESSING... <span className="icoProgress material-symbols-outlined">timer_3_alt_1</span></button>
                        </>
                        :
                        (isManceTierAssociated
                            && !isManceTierOwner
                            && !isLeemonTierOwner
                            && isLeemonTierAssociated
                            && isFounder
                            && manceAndLeemonStatus === 'Not Claimed')
                            ?
                            <>
                            <button className='btn2' onClick={claimFTTokens}>CLAIM <span className="icoTask material-symbols-outlined">emoji_events</span></button>
                            </>
                            :
                            (!isLeemonTierAssociated
                                && !isLeemonTierOwner
                                && !isManceTierOwner
                                && !isManceTierAssociated
                                && isFounder)
                                ?
                                <>
                                <button className='btn2' onClick={associateToken}>ASSOCIATE TOKENS  <span className="icoProgress material-symbols-outlined">settings_alert</span></button>
 
                                </>
                                :
                                (isLeemonTierAssociated === false
                                    && isLeemonTierOwner === false
                                    && isManceTierOwner === false
                                    && isManceTierAssociated === false
                                    && isFounder === false
                                    && isConnected === true)
                                    ?
                                    <>
                                    <button className='btn2'>LOCKED <span className="icoLocked material-symbols-outlined">lock</span></button>
                                    </>
                                    :
                                    <>
                                      <button className='btn2'>LOCKED <span className="icoLocked material-symbols-outlined">lock</span></button>
                                    </>
            } */}
			   <>
                                      <button className='btn2'>LOCKED <span className="icoLocked material-symbols-outlined">lock</span></button>
                                    </>
          {/* {userId ? (
						<button id="btnConnect" className="btn2" onClick={disconnectBrowserExtension}>Disconnect</button>
					) : (
						<button id="btnConnect" className="btn2" onClick={() => openConnectWindow()}>Connect</button>
					)
					} */}
        </div>
      </div>

      <ul className="circles">
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
      </ul>
    </section>
    </>
  );
};

export default RantCPU;
